// extracted by mini-css-extract-plugin
module.exports = {"contentDiv":"layout_contentDiv__UZaKL","logo":"layout_logo__RqH9D"};